import { render, staticRenderFns } from "./GTextFormInput.vue?vue&type=template&id=4ba5d7f0&scoped=true&"
import script from "./GTextFormInput.vue?vue&type=script&lang=ts&"
export * from "./GTextFormInput.vue?vue&type=script&lang=ts&"
import style0 from "./GTextFormInput.vue?vue&type=style&index=0&id=4ba5d7f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba5d7f0",
  null
  
)

export default component.exports